import React, { useEffect, useState } from "react";
import {
  resetUserPassword,
  updateEmail,
  updateMemberEmail,
} from "../../../../Utils/SupabaseServices/UserDatabase";
import validator from "validator";
import { supabase } from "../../../../config/supabaseClient";
import { Button, Input, Modal } from "antd";
import axios from "axios";
import HelperText from "../../../../components/HelperText/HelperText";
import { TRACKING_TYPES } from "../../../../Utils/SupabaseServices/Track";
import track from "../../../../Utils/SupabaseServices/Track";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../../hooks/useAuth";

const Email = (props: any) => {
  const {
    user_id,
    username,
    userData,
    setIsEmail,
    setIsEmailVerified,
    isAdmin,
    setIsEmailChanged,
    isEmailChanged
  } = props;

  const { isMember, session } = useAuth();
  // Get the phone from appropriate source based on user type
  const getInitialEmail = () => {
    if (!isAdmin && isMember && session?.user?.email !== userData?.email) {
      // For members, try to get phone from their auth metadata or user data
      return userData?.team_members?.find((member: any) => member?.email === session?.user?.email)?.email || "";
    }
    return userData?.email || "";
  };

  const [email, setEmail] = useState(getInitialEmail());
  const [originalEmail, setOriginalEmail] = useState(getInitialEmail()); // Store the original email value

  const [editEmail, setEditEmail] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [isEmailVerify, setIsEmailVerify] = useState<any>(
    userData?.email_verify
  );
  const [otp, setOTP] = useState("");
  const [modalError, setModalError] = useState("");
  const [modalContent, setModalContent] = useState(false);
  const [isTabsLocked, setIsTabsLocked] = useState<any>();
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const [isInstructionsSent, setIsInstructionsSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const handleStorageChange = () => {
      const data = localStorage.getItem("email_verify");
      if (data === "false") {
        setIsTabsLocked(true);
      } else {
        setIsTabsLocked(false);
      }
    };

    // Add event listener for storage changes
    window.addEventListener("storage", handleStorageChange);

    // Initial setup (run once)
    handleStorageChange();

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [window]);

  const validateEmail = async (email: any) => {
    if (validator.isEmail(email)) {
      return true;
    } else {
      localStorage.setItem("email_verify", "false");
      setEmailError("Enter Valid Email!");
      // showModal();
      setIsEmail(false);
      if (!isAdmin && isMember && session?.user?.email !== userData?.email) {
        await updateMemberEmail(user_id, session?.user?.id, session?.user?.email, email);
      } else {
        await updateEmail(user_id, username, email);
      }
      props.refetch();
    }
  };

  async function sendEmailOTP() {
    setOTP("");
    setModalError("");
    setIsModalOpen(true);
    setModalContent(true);

    try {
      const { data, error } = await supabase.auth.signInWithOtp({
        email: email,
      });

      if (error) {
        setModalError(error.message);
        console.error("OTP Error:", error);
        return;
      }

      // Success case
      setModalError(""); // Clear any previous errors
    } catch (err) {
      console.error("Unexpected error:", err);
      setModalError(
        err instanceof Error ? err.message : "An unexpected error occurred"
      );
    }
  }

  function handleUpdateValue(e: any, option: any) {
    if (option === "email") {
      setEmail(e.target.value);
    }
  }

  // Add function to check if email exists in database
  const checkEmailExists = async (email: string) => {
    const { data, error } = await supabase
      .from("user")
      .select("*")
      .eq("email", email);

    if (data && data.length > 0 && data[0].email === email) {
      return true;
    } else {
      // check if the email is a member of the creator
        const { data: creatorData } = await supabase
          .from("user")
          .select("team_members")
          .eq("email", userData?.email);
        if (creatorData && creatorData.length > 0) {
          const teamMembers = creatorData[0].team_members;
          const member = teamMembers.find((member: any) => member.email === email);
          if (member && member?.length > 0) {
          return true;
        }
      }
      return false;
    }
  };

  const doneEdit = async (option: any) => {
    if (option === "email") {
      setIsEmailChanged(true);
      const newEmail = email.trim().toLowerCase();

      // Check if email is unchanged
      if (newEmail === originalEmail) {
        setEmailError("New email cannot be the same as current email");
        return;
      }

      // Validate email format
      if (!validator.isEmail(email)) {
        setEmailError("Please enter a valid email");
        return;
      }

      const emailExists = await checkEmailExists(newEmail);
      if (emailExists) {
        setEmailError("This email is already registered with another account");
        return;
      }

      if (!isAdmin && isMember && session?.user?.email !== userData?.email) {
        await updateMemberEmail(user_id,session?.user?.id, session?.user?.email, newEmail);
        
        try {
            // Update localStorage member data with new email
            const memberData = JSON.parse(localStorage.getItem("member") || '{}');
            if (memberData.email) {
              memberData.email = newEmail;
              localStorage.setItem("member", JSON.stringify(memberData));
            }
          
        } catch (error) {
          console.error("Error updating auth email:", error);
        }
        
        props.refetch();
      } else {
        await updateEmail(user_id, username, newEmail);
        props.refetch();
      }
      // await updateEmail(user_id, username, newEmail);
      localStorage.setItem("email_verify", "false");
      setEditEmail(false);
      setIsEmail(true);
      setIsEmailVerify(false);
      setIsEmailVerified(false);
      setOriginalEmail(newEmail); // Update the original email after successful change
      setEmailError(""); // Clear any error messages
      setInterval(() => {
        setIsEmailChanged(false);
      }, 1000);
    }
  };

  async function verifyEmail() {
    try {
      const { data, error } = await supabase.auth.verifyOtp({
        email: email,
        token: otp,
        type: "email",
      });

      if (error) {
        setModalError(error.message);
        return;
      }

      // Update user record on successful verification
      const { error: updateError } = await supabase
        .from("user")
        .update({
          email_verify: true,
        })
        .eq("username", username);

      props.refetch();

      if (updateError) {
        setModalError(updateError.message);
        return;
      }

      // Success case
      localStorage.setItem("email_verify", "true");
      setIsModalOpen(false);
      props.setIsEmail(true);
      props.setIsEmailVerified(true);
      props.setChangedEmail(email);
      setIsEmailVerify(true);
      props.refetch();
      setModalError(""); // Clear any error messages
    } catch (error) {
      console.error("Verification error:", error);
      setModalError(
        error instanceof Error ? error.message : "An unexpected error occurred"
      );
    }
  }
  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      return;
    }

    // setIsLoading(true);

    try {
      // First check if the email exists in the database
      const { data: existingUser } = await supabase
        .from("user")
        .select("*")
        .eq("email", email);
      if (!existingUser || existingUser.length === 0) {
        // setError("No account found with this email address");
        // setMsg("");
        // setIsLoading(false);
        // check wether this email is a member of any userData?.email creator
        const { data: creatorData } = await supabase
          .from("user")
          .select("team_members")
          .eq("email", userData?.email);
        if (creatorData && creatorData.length > 0) {
          const teamMembers = creatorData[0].team_members;
          const member = teamMembers.find((member: any) => member.email === email);
          if (!member || member.length === 0) {
            return;
          }
        }
        return;
      }

      const resetResponse = await resetUserPassword(email);
      if (!resetResponse || resetResponse?.success === false) {
        let rawError = resetResponse?.error || "Failed to reset password";
        if (typeof rawError !== "string") {
          rawError = String(rawError?.message || rawError);
        }
        const userMessage = rawError.includes(":")
          ? rawError.split(":").slice(1).join(":").trim()
          : rawError;
        setError(userMessage);
        setMsg("");
      } else {
        setMsg("Password reset instructions sent to your email!");
        setError("");
        setIsInstructionsSent(true);
        track(location.pathname, TRACKING_TYPES.PAGE, {
          pathname: location.pathname,
          details: { email: email },
        });
      }
    } catch (err: any) {
      setError(err.message);
      setMsg("");
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        setIsInstructionsSent(false);
        setError("");
        setMsg("");
      }, 20000);
    }
  };
  return (
    <div className="account-tile">
      <div className="account-tile-header">
        <div className="account-tile-title">
          <p>Email</p>
          <HelperText message="This is the email connected to your account." />
        </div>
      </div>
      <div className="account-tile-value">
        {!editEmail ? (
          <div
            style={!isEmailVerify ? {} : { alignItems: "center", gap: "10px" }}
          >
            <div style={{ margin: "0.25rem 0 1.25rem" }}>{email}</div>
            <div style={{ gap: "16px" }} className="account-button-group">
              {!isEmailVerify && (
                <Button
                  className="accountButton"
                  style={{ marginTop: "0rem" }}
                  onClick={() => {
                    sendEmailOTP();
                  }}
                >
                  Verify Email
                </Button>
              )}
              <Button
                className="accountButton"
                onClick={() => {
                  setEditEmail(true);
                }}
                style={{
                  width: "100%",
                  marginRight: '0',
                  marginTop: "0rem",
                  padding: "0.5rem 1rem",
                }}
              >
                Change
              </Button>
            </div>
            {/* {isAdmin && (
              <>
                <Button
                  type="link"
                  style={{
                    textDecoration: "underline",
                    padding: 0,
                    height: "auto",
                  }}
                  onClick={(e: any) => {
                    handleResetPassword(e);
                    // setEditEmail(true);
                  }}
                >
                  Reset Password
                </Button>
                {error && <p className="error-message">{error}</p>}
                {msg && (
                  <div
                    className="success-message"
                    style={{
                      color: "#10B981",
                      backgroundColor: "rgba(16, 185, 129, 0.1)",
                      padding: "12px 16px",
                      borderRadius: "8px",
                      fontSize: "14px",
                      marginBottom: "20px",
                    }}
                  >
                    <p style={{ margin: 0 }}>{msg}</p>
                  </div>
                )}
              </>
            )} */}
          </div>
        ) : (
          <div>
            <input
              type="email"
              style={{
                width: "100%",
                padding: "0.5rem",
                borderRadius: "6px",
                border: "1px solid #e5e7eb",
                marginBottom: "0.75rem",
              }}
              onChange={(e: any) => handleUpdateValue(e, "email")}
              value={email}
            />
            <div className="account-button-group">
              <Button
                className="accountButton"
                onClick={() => {
                  doneEdit("email");
                }}
              >
                Save
              </Button>
              <Button
                className="cancelButton"
                onClick={() => {
                  setEditEmail(false);
                  setEmailError("");
                  setEmail(originalEmail); // Reset email back to original value
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
        )}
      </div>
      {emailError && (
        <p
          style={{
            color: "#ef4444",
            fontSize: "0.875rem",
            marginTop: "0.5rem",
          }}
        >
          {emailError}
        </p>
      )}

      {!isEmailVerify && !editEmail && (
        <div
          style={{
            backgroundColor: "rgba(36, 70, 240, 0.08)",
            borderRadius: "8px",
            padding: "12px 16px",
            marginTop: "12px",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
            border: "1px solid rgba(36, 70, 240, 0.1)",
          }}
        >
          <p
            style={{
              margin: 0,
              color: "#2446f0",
              fontSize: "14px",
              lineHeight: "1.5",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {/* <span style={{ fontWeight: 500 }}>Email Verification Required</span> */}
            Please verify your email address to access all features and ensure
            account security.
          </p>
        </div>
      )}

      <Modal
        title="Email Verification"
        open={isModalOpen}
        onCancel={handleCancel}
        className="account-modal"
        footer={null}
      >
        <div>
          {modalContent && (
            <>
              <div
                style={{
                  textAlign: "center",
                  marginBottom: "8px",
                }}
              >
                <p
                  style={{
                    color: "#374151",
                    fontSize: "14px",
                    marginBottom: "16px",
                  }}
                >
                  Please enter the 6-digit verification code sent to your email
                </p>
                <Input
                  type="text"
                  maxLength={6}
                  style={{
                    width: "240px",
                    height: "44px",
                    fontSize: "16px",
                    textAlign: "center",
                    letterSpacing: "0.2em",
                    borderRadius: "8px",
                    marginBottom: "16px",
                  }}
                  placeholder="Enter OTP"
                  onChange={(e: any) => setOTP(e.target.value)}
                  value={otp}
                />
                <Button
                  type="primary"
                  style={{
                    width: "240px",
                    height: "44px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: 500,
                    // backgroundColor: '#2446f0',
                    border: "none",
                  }}
                  onClick={verifyEmail}
                >
                  Verify Email
                </Button>
              </div>
            </>
          )}
          {modalError && (
            <p
              style={{
                color: "#ef4444",
                fontSize: "14px",
                margin: "8px 0 0",
                textAlign: "center",
              }}
            >
              {modalError}
            </p>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default Email;

// 		{modalTitle.includes("Phone") ? (
// 			<>
// 				<input
// 					type='text'
// 					className='otp-input'
// 					placeholder='Enter 6 digit OTP'
// 					onChange={(e: any) => setOTP(e.target.value)}
// 					value={otp}
// 				/>
// 				<button
// 					className='modal-verify-btn'
// 					onClick={verifyPhoneNumber}
// 				>
// 					Verify
// 				</button>
// 			</>
// 		) : modalTitle.includes("Email") ? (
// 			<>

//                  : (
// 	""
// )}
